import { Component, Input } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { EditableAccount } from '../../model/account.model';

@Component({
    selector: 'jhi-identite-personne',
    templateUrl: './identite-personne.component.html',
    styleUrls: ['./identite-personne.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class IdentitePersonneComponent  {
    @Input()
    identite: EditableAccount;

    @Input()
    isFCUser: boolean;

    @Input()
    isRepresentant: boolean;

    @Input()
    isCreateAccountBtnClicked: boolean;


}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/identite-personne/identite-personne.component.ts